<template>
    <div class="download">
        <van-nav-bar
            title="资料下载"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="buttons">
            <img src="//cdn.edstatic.com/203012120000/edccb31f9633d87bc88e2a73b1a11eaf/2023/07/1d9550b1-934d-4428-b4c6-5f3a4d5e7e98.png"  @click="goInvite(4252)"/>
            <img src="//cdn.edstatic.com/203012120000/ac7eabf9b73441214a1b8775f74f46e3/2023/07/9f090e9e-2ab1-47af-a7da-d0d530526e9c.png"  @click="goInvite(4251)"/>
            <img src="//cdn.edstatic.com/203012120000/65c7eeebeba977eeb0b9ca2de90f53ca/2023/07/9938b722-58c5-4b6c-aee4-c4174b2e876f.png" @click="goPPTs"/>
            <img src="//cdn.edstatic.com/203012120000/86edbacac5ba19443c9fe8ea70e2cce5/2023/07/bb175f44-0d93-4962-9dee-da2400b94c92.png" style="width:100%" @click="goInvite(4250)"/>
        </div>
        <img src="@/assets/images/cvscf2023/bottom.png" class="bottom"/>
    </div>
</template>

<script>
import Top from '../VascularSystem/components/Top.vue'
import { ButtonDetail } from '../../config/interface.js'
export default {
    components:{
        Top
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
    methods:{
        goDetail(type){

        },
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
        onClickLeft(){
            this.$router.push('/CVSCF2023/index')
        },
        goPPTs(){
			this.$router.push('/CVSCF2023/ppt?meeting_id=399&button_id='+this.button_id)
        },
        goInvite(id){
			this.$router.push('/CVSCF2023/invite?meeting_id=399&id='+id)
        }
    }
}
</script>

<style lang="scss" scoped>
.van-nav-bar{
    background: #d8261d;
    .van-icon{
        color: white;
    }
}
.van-nav-bar /deep/.van-icon {
    color: white;
}
 .van-nav-bar /deep/.van-nav-bar__title{
    color: white;
    font-size: 16px;
    letter-spacing: 0.5px;
}
.download{
    .buttons{
        padding:15% 5%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        img{
            width: 31%;
            margin-bottom: 4%;
        }
    }
    .bottom{
        position: absolute;
        width: 100%;
        bottom: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/CVSCF2023/download.vue